


























































































































































//import CategoriaDistanciaCarreraAdd from "./DistanciaCarreraAdd.vue";
import Vue from "vue";
/*
import DistanciaCarreraService, {
  DistanciaCarreraCreateDto
} from "@/api/carrera/detalle/DistanciaCarrera.service";
*/

//import DistanciaService, { DistanciaCreateDto } from "@/api/DistanciaService";
import RegistradosPendientesEntregaAdd from "./RegistradosPendientesEntregaAdd.vue";
import RegistradosPendientesEntregaCambiarRegistroAdd from "./RegistrosPendienteEntregaCambiarRegistroAdd.vue";
import RegistroCarreraService, {
  RegistroCarreraCreateDto
} from "@/api/carrera/detalle/RegistroCarreraService";
import XLSX from "xlsx";
import moment from "moment";

export default Vue.extend({
  components: {
    //CategoriaDistanciaCarreraAdd
    RegistradosPendientesEntregaAdd,
    RegistradosPendientesEntregaCambiarRegistroAdd
  },
  data() {
    return {
      search: "",
      dialog: false,
      dialog2: false,
      /*
      distanciasBase: [] as DistanciaCreateDto[],
      dato: {
        nombre: ""
      } as DistanciaCarreraCreateDto,
      */
      headers: [
        { text: "#", value: "id" },
        { text: "Identificación", value: "persona.identificacion" },
        //{ text: "Nombre", value: "persona.nombre" },
        //{ text: "Apellido", value: "persona.apellido" },
        { text: "Nombre Registrado", value: "persona.displayNombreCompleto" },

        { text: "Telf.", value: "persona.telefono" },
        { text: "Nacimiento", value: "persona.fechaNacimiento" },
        { text: "Edad", value: "persona.edad" },
        //{ text: "Distancia", value: "distancia.nombre" },
        //{ text: "Categoria", value: "categoria.nombre" },
        //{ text: "Talla", value: "tallaCamiseta.talla.nombre" },
        //{ text: "Personalización", value: "personalizacionCamiseta" },
        { text: "Kit", value: "kitEntregable", sortable: false, width: "15%" },
        { text: "Distancia", value: "distancia.nombre" },
        { text: "Categoria", value: "categoria.displayCategoria" },
        { text: "Regalo", value: "regaloDisplay" },
        { text: "Informacion Adicional Externa", value: "externalInfoDisplay" },
        { text: "Nota Registro", value: "notaRegistro" },
        { text: "Acción", value: "accion", sortable: false }

        //{ text: "Teléfono", value: "telefono", sortable: false }
        //{ text: "Precio", value: "precio.nombre" }
        //{ text: "Estado", value: "estado" },
        //{ text: "createdOn", value: "createdOn", sortable: false },
        //{ text: "Acción", value: "actions", sortable: false }
      ],
      datos: [] as RegistroCarreraCreateDto[],
      totalRecaudado: "0.00",
      dato: {
        id: 0
      } as RegistroCarreraCreateDto
    };
  },
  methods: {
    getMapUrl(value: any) {
      let url = "";
      try {
        //http://www.google.com/maps/place/lat,lng
        const loc = JSON.parse(value);
        if (loc && loc.lat && loc.lng) {
          url = `http://www.google.com/maps/place/${loc.lat},${loc.lng}`;
        } else {
          throw new Error("Coordenada no es valida");
        }
      } catch {
        //
      }
      return url;
    },
    loadTotalRecaudado() {
      let total = 0;
      for (const doc of this.datos) {
        const p = doc as any;
        total += Number(p.precio.precio);
      }
      this.totalRecaudado = total.toFixed(2);
    },
    exportExcel() {
      //const data = XLSX.utils.json_to_sheet(this.datos);
      const data = XLSX.utils.table_to_sheet(
        document.getElementById("tablita")
      );
      const workbook = XLSX.utils.book_new();
      const filename = "carrera-registros-pagados";
      XLSX.utils.book_append_sheet(workbook, data, filename);
      XLSX.writeFile(workbook, `${filename}.xlsx`);
    },
    setDefaultItem() {
      const newDto = {
        nombre: "",
        distancia: 0,
        edadMinima: 0,
        edadMaxima: 0
      };
      //this.dato = newDto;
    },

    editItem(item: RegistroCarreraCreateDto) {
      this.dato = item;
      this.dialogChange(true);
    },
    editItem2(item: RegistroCarreraCreateDto) {
      this.dato = item;
      this.dialogChange2(true);
    },
    /*
    newItem() {
      this.setDefaultItem();
      this.dialogChange(true);
    },
    */
    dialogChange(value: boolean) {
      this.dialog = value;
    },
    dialogChange2(value: boolean) {
      this.dialog2 = value;
    },
    /*
    entregar(idRegistro: number) {
      RegistroCarreraService.entregarRegistroPendienteEntrega(idRegistro)
        .then(() => {
          this.$swal({
            icon: "success",
            title: "Entrega",
            text: "Se guardo correctamente "
          });
          //
        })
        .catch(() => {
          this.$swal({
            icon: "error",
            title: "Entrega",
            text: "No se pudo guardar"
          });
        })
        .finally(() => {
          this.getAll();
        });
    },
    */
    getAll() {
      RegistroCarreraService.getRegistrosPendientesEntrega(
        this.$route.params.id
      )
        .then(response => {
          this.datos = (response as any[]).map(item => ({
            ...item,
            regaloDisplay: this.getRegaloDisplay(item?.pedido),
            externalInfoDisplay: this.getExternalInfoDisplay(
              item?.pedido?.datosAdicionales
            )
          }));
          //this.loadTotalRecaudado();
        })
        .catch(() => {
          this.$swal({
            toast: true,
            position: "center",
            showConfirmButton: false,
            timer: 2000,
            icon: "error",
            title: "Registros Pagados",
            text: "No se pudo obtener"
          });
        });
    },
    downloadExport() {
      RegistroCarreraService.getRegistrosPagadosExcel(this.$route.params.id)
        .then(response => {
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(new Blob([response.data]));
          const today = new Date();
          moment.locale("es");
          link.setAttribute(
            "download",
            `carrera-${this.$route.params.id}_${moment(today).format(
              "YYYY-MMMM-DD"
            )}.xlsx`
          ); //"carrera-reporte.xlsx"
          document.body.appendChild(link);
          link.click();
        })
        .catch(() => {
          console.log("no se pudo generar el documento");
        });
    },
    getExternalInfoDisplay(datosAdicionales: any): string {
      const detalleRegalo = this.extractDetalleRegalo(datosAdicionales);
      return detalleRegalo ? String(detalleRegalo).trim() : "";
    },
    getRegaloDisplay(pedido: any): string {
      const value = pedido?.infoRegalo;
      if (value === null || value === undefined) {
        return "";
      }
      return String(value).trim();
    },
    extractDetalleRegalo(datosAdicionales: any): string {
      if (!datosAdicionales || typeof datosAdicionales !== "object") {
        return "";
      }

      const fromDirect = this.readDetalleRegaloFromContainer(datosAdicionales);
      if (fromDirect) {
        return fromDirect;
      }

      for (const value of Object.values(datosAdicionales)) {
        const nested = this.readDetalleRegaloFromContainer(value);
        if (nested) {
          return nested;
        }
      }

      return "";
    },
    readDetalleRegaloFromContainer(container: any): string {
      if (!container || typeof container !== "object") {
        return "";
      }

      if (container.detalleRegalo) {
        return String(container.detalleRegalo);
      }

      const rawPagoExtraInfo = container.pagoExtraInfo;
      if (!rawPagoExtraInfo) {
        return "";
      }

      if (typeof rawPagoExtraInfo === "object" && rawPagoExtraInfo.detalleRegalo) {
        return String(rawPagoExtraInfo.detalleRegalo);
      }

      if (typeof rawPagoExtraInfo === "string") {
        try {
          const parsed = JSON.parse(rawPagoExtraInfo);
          if (parsed && typeof parsed === "object" && parsed.detalleRegalo) {
            return String(parsed.detalleRegalo);
          }
        } catch {
          return "";
        }
      }

      return "";
    }
  },
  mounted() {
    this.getAll();
  },
  watch: {
    dialog: function(newVal) {
      if (newVal === false) {
        this.setDefaultItem();
      }
    }
  }
});
